import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { pushCollectionAction } from "../../CollectionUtils";
// The backend serialises open-ended bounds (C# int?) as null/undefined. Normalise to null so
// comparisons with FilterSettings (which uses null for "no bound") stay consistent.
const normalise = (v)=>v ?? null;
export const AgeRangeFilter = (param)=>{
    let { AgeRanges, ageFrom, ageTo, updateAgeRange } = param;
    const push = pushCollectionAction();
    const updatePredefinedRange = (from, to, label)=>{
        push(`filter-age-range`, label);
        updateAgeRange(from, to);
    };
    if (!AgeRanges || AgeRanges.length === 0) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs("div", {
        className: "c-filter__group",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "c-filter__group-title",
                children: "Leeftijd"
            }),
            AgeRanges.map((param)=>{
                let { Id, Label, From, To, Count } = param;
                const from = normalise(From);
                const to = normalise(To);
                const inputId = `age-range-${Id}`;
                const labelId = `age-range-label-${Id}`;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "c-filter__radio",
                    children: [
                        /*#__PURE__*/ _jsx("input", {
                            type: "radio",
                            id: inputId,
                            name: "age-range",
                            checked: ageFrom === from && ageTo === to,
                            onChange: ()=>updatePredefinedRange(from, to, Label),
                            "aria-describedby": labelId
                        }),
                        /*#__PURE__*/ _jsxs("label", {
                            id: labelId,
                            className: "c-filter__radio-label",
                            htmlFor: inputId,
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "radio-label__name",
                                    children: Label
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "radio-label__count",
                                    children: Count
                                })
                            ]
                        })
                    ]
                }, inputId);
            })
        ]
    });
};
